import React from 'react'
const Pencil = () => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.666667"
        y="10.3385"
        width="10.6667"
        height="2.66667"
        stroke="black"
        strokeWidth="1.33333"
      />
      <path
        d="M2.18588 10.3359L4.51922 1.0026H7.47818L9.81151 10.3359H2.18588Z"
        stroke="black"
        strokeWidth="1.33333"
      />
      <rect x="3.33398" y="5" width="5.33333" height="1.33333" fill="black" />
    </svg>
  )
}

export default Pencil
